<template>
  <div class="error-page">
    <div class="error-page__container">
      <app-svg
        id="404"
        class="error-page__icon"
      />
      <div class="error-page__message">
        <div class="error-page__404">
          404
        </div>
        <div class="error-page__text">
          Данная страница не существует, или была перенесена. Пожалуйста, перейдите на Главную страницу или ознакомьтесь
          с нашими услугами.
        </div>
        <AppButton
          class="error-page__action"
          to="/"
        >
          Перейти на главную
        </AppButton>
      </div>
    </div>
    <ServicesSection />
  </div>
</template>
<script>
import ServicesSection from "@/components/ServicesSection.vue";
import AppButton from "@/components/ui/AppButton.vue";

export default {
  components: {
    AppButton,
    ServicesSection,
  },
};
</script>
<style lang="scss" scoped>
.error-page {
  $that: &;

  padding: 180px 0 64px;

  @include tablet {
    padding: 160px 0 50px;
  }

  &__container {
    @extend %container;
    max-width: calc(1200px + 56px * 2);
    padding-bottom: 64px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    @include tablet {
      justify-content: center;
      padding-bottom: 50px;
    }
  }

  &__icon {
    width: 436px;
    height: 369px;

    @include laptop {
      width: calc(436 / 1279 * 100vw);
      height: calc(369 / 1279 * 100vw);
      margin-right: 30px;
    }

    @include tablet {
      display: none;
    }
  }

  &__message {
    width: 100%;
    max-width: 636px;

    @include tablet {
      text-align: center;
    }
  }

  &__404 {
    margin-bottom: 13px;
    font-weight: 300;
    font-size: 100px;
    line-height: 126px;
    letter-spacing: -1.5px;
  }

  &__text {
    margin-bottom: 41px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }

  &__action {
    text-align: center;
  }
}
</style>
